import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginData } from "../store/Slice/AdvisorAuthSlice";
import logo from "../assets/images/foxtoxlogo.png";
import { Eye, EyeOff } from "lucide-react";

const AdvisorLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [wrong, setWrong] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { auth, error } = useSelector((state) => state.advisorauth);

  useEffect(() => {
    console.log(auth, error);
    if (auth === true) {
      navigate("/advisordashboard");
    } else {
    }
  }, [auth]);

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setWrong(true);
    const response = await dispatch(loginData({ username, password }));

    try {
      if (response?.payload?.token) {
        document.cookie = `authToken=${
          response?.payload?.token
        }; expires=${1}; path=/`;
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //   const handleSubmit = async () => {

  //     try {
  //         //TODO: Create User and Navigate to customer Dashboard
  //         const response = await dispatch(createUser({
  //             "email": email,
  //             "firstName": firstName,
  //             "lastName": lastName,
  //             "phoneNumber": phoneNumber,
  //         })).unwrap();
  //         console.log("New user response", response);

  //         try {
  //             // const userData = await apiServices.post('identity/customerByNumber', {}, { phoneNumber: phoneNumber });
  //             // console.log("fetching newly created userData in OnboardingForm: ", userData);
  //             // dispatch(postLoginData(userData));
  //             if(response?.token){
  //                 document.cookie = `authToken=${response?.token}; expires=${1}; path=/`;
  //             }
  //             navigate(`/dashboard`)
  //         } catch (error) {
  //             console.log(error.message)
  //         }
  //     } catch (error) {
  //         console.log(error.message);
  //     }

  // };

  return (
    <>
      <div className="block mx-auto text-[#454545] w-full font-['Roboto',sans-serif] h-screen">
        <div className="header-container"></div>
        <div className="flex flex-col justify-center items-center my-[10%] mx-auto">
          <div
            style={{
              display: "inline-flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <img
              style={{ width: "240px", height: "120px", cursor: "pointer" }}
              src={logo}
              alt=""
              onClick={() => navigate("/")}
            />
            <p className="text-2xl font-bold">
              Welcome to <span className="text-primary">foxtox</span>
            </p>
          </div>

          <div
            style={{
              display: "inline-flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <div className="mt-[20%]">
              <p className="text-[#222] font-['Roboto'] text-2xl font-bold leading-normal">
                Login to your Broker account
              </p>
            </div>

            <form onSubmit={handleSubmit} className="p-5">
              <h2 className="form-header">Username</h2>
              <input
                type="text"
                value={username}
                onChange={handleUsernameChange}
                placeholder="Enter your username"
                className="flex h-11 py-2.5 px-3 items-center gap-2 w-[19.12rem] flex-1 rounded-lg border border-brand-border bg-white focus:border-[#1569ab] focus:outline-[#1569AB]"
                required
              />
              <div className="spacer" style={{ height: "1rem" }} />
              <h2 className="form-header">Password</h2>
              <div className="relative w-[19.12rem]">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={handlePasswordChange}
                  placeholder="Enter your password"
                  className="flex h-11 py-2.5 px-3 items-center gap-2 w-full flex-1 rounded-lg border border-brand-border bg-white focus:border-[#1569ab] focus:outline-[#1569AB]"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                  {showPassword ? (
                    <Eye size={20} strokeWidth={1.5} />
                  ) : (
                    <EyeOff size={20} strokeWidth={1.5} />
                  )}
                </button>
              </div>
              <button
                type="submit"
                className="w-full py-2.5 px-2.5 bg-gradient-to-r from-primary to-primary-green text-white border-none rounded cursor-pointer mt-7 hover:opacity-90"
              >
                Login
              </button>
              {wrong && (
                <div style={{ color: "red", marginTop: "0.5rem" }}>{error}</div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdvisorLogin;
